export const getSelectedFinish = (allFinishes, selectedFinishName) => {
  if (!allFinishes || !selectedFinishName) {
    return undefined;
  }
  return allFinishes.find((f) => f.name === selectedFinishName);
};
